<template>
   <el-dialog
    :visible.sync="visible"
    :before-close="closeDialog"
    width="1400px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
      <page-view class="page-contract-search mwclg-style  ">
        <div slot="pageRight">
          <div class="order-search">
            <p class="title">订阅查询</p>
            <div class="flex">
              <el-form
                ref="searchForm"
                :model="searchForm"
                style="flex: 1"
                label-width="100px"
              >
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="订阅主题">
                      <el-input v-model="searchForm.MailSubject" size="small" placeholder="请输入内容" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="起运港">
                      <el-input v-model="searchForm.POLName" size="small" class="custom-input" placeholder="请输入内容" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="目的港">
                      <el-input v-model="searchForm.PODName" size="small" class="custom-input" placeholder="请输入内容" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="品名">
                      <el-input v-model="searchForm.GoodsName" size="small" class="custom-input" placeholder="请输入内容" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="订阅类型">
                      <el-select v-model="searchForm.SubType" placeholder="请选择" size="small">
                        <el-option
                          v-for="item in Object.values(IsTypeS)"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
              <div style="margin-top: 10px">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="search"
                >查询</el-button
                >
                <el-button
                  size="small"
                  icon="el-icon-refresh-right"
                  @click="reset"
                >重置</el-button
                >
              </div>
            </div>
          </div>
          <div class="order-list">
            <div
                class="company-info-block"
                v-loading="fullscreenLoading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(196,196,204, 0.8)"
                >
                <p class="title">订阅信息</p>
                <div class="company-name-container flex">
                  <el-button type="primary" size="small" @click="addMilestone" icon="el-icon-plus">新增订阅</el-button>
                </div>
                <div class="table_content">
                  <el-table v-loading="tableLoading" :data="tableData" stripe height="400" style="width: 100%">
                    <el-table-column type="index" :index="indexMethod" label="序号" width="50" ></el-table-column>
                    <el-table-column prop="MailSubject" label="订阅主题" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="SubTypeTxt" label="订阅类型" width="100" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="POLName" label="起运港" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="PODName" label="目的港" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="GoodsName" label="品名" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="MailTo" label="接收人邮件" width="250" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="MailCC" label="抄送人邮件" width="250" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="CreaterName" label="创建人" width="190"></el-table-column>
                    <el-table-column
                    label="创建时间"
                    prop="CreateDT"
                    width="150"
                    :formatter="(row)=>{
                      return conversionTime(row.CreateDT)
                    }"
                   />
                    <el-table-column label="操作" width="90" fixed="right" align="center">
                      <template #default="{row}">
                        <el-button type="text" @click="editMilestone(row)">修改</el-button>
                        <el-popconfirm
                          title="是否删除订阅信息？"
                          @confirm="deleteMilestone(row)"
                        >
                          <el-button slot="reference" type="text" style="margin-left:8px;">删除</el-button>
                        </el-popconfirm>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
            </div>
          </div>
        </div>
      </page-view>
    <MilestoneTETemDialog :visible.sync="dialogVisible" :milestoneInfo="milestoneInfo" @submit="onCompanyFormSubmit"></MilestoneTETemDialog>
  </el-dialog>
</template>

<script>
import GMS_TANKMILESTONE from '@/assets/json/gmsMilestone.json'
import dialog from '@/components/fms/mixins/dialog';
import { conversionTime } from '@/utils/index'
import MilestoneTETemDialog from '@/components/gms/TE/milestoneTemDialog'
import { getMilestoneList, delMilestone } from '@/api/gmsTank.js'
export default {
  name: 'MilestoneTEList',
  components: { MilestoneTETemDialog },
  mixins: [dialog],
  props: {
    customerCode: {
      type: String,
      default: ''
    },
    customerName: {
      type: String,
      default: ''
    },
    jobtype: {
      type: String,
      default: ''
    },
    jobTypeId: {
      type: String,
      default: ''
    },
    tableName: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      milestoneInfo: {
        JobType: this.jobtype,
        Job_TypeId: this.jobTypeId,
        TableName: this.tableName,
      },
      searchForm: {
        Booking_No: '',
        MailSubject: '',
        CustomerCode: '',
        SubType: '',
        JobType: '',
      },
      tableLoading: false,
      dialogVisible: false,
      fullscreenLoading: false,
      tableData: [],
      loading: false,
      conversionTime,
      IsTypeS: [
        { name: '全部', id: '' },
        { name: '航线', id: 1 },
        { name: '品名', id: 2 },
        { name: '自定义', id: 3 }
      ],
    }
  },
  created () {
    this.search()
  },
  methods: {
    async search() {
      this.tableLoading = true
      const data = {}
      this.searchForm.CustomerCode = this.customerCode
      this.searchForm.SourceType = 'Template'
      this.searchForm.JobType = this.jobtype
      data.queryJson = JSON.stringify(this.searchForm)
      await getMilestoneList(data).then(res => {
        if (res && res.data && res.data.length) {
          var data = JSON.parse(res.data)
          const result = data?.rows ?? []
          this.tableData = result;
        }
      })
      this.tableLoading = false
    },
    goSearch() {},
    searchTimeChange() {},
    currentPageChange() {},
    exportInvoiceDetail() {
      console.log('exportInvoiceDetail')
    },
    addMilestone() {
      this.milestoneInfo = {
        Type: '1',
        SourceType: 'Template',
        JobType: this.jobtype,
        Job_TypeId: this.jobTypeId,
        TableName: this.tableName,
        CustomerCode: this.customerCode,
        CustomerName: this.customerName
      }
      this.dialogVisible = true
    },
    editMilestone(row) {
      this.milestoneInfo = {
        ...row,
        SourceType: 'Template',
        JobType: this.jobtype,
        Job_TypeId: this.jobTypeId,
        TableName: this.tableName,
        CustomerCode: this.customerCode,
        CustomerName: this.customerName
      }
      this.dialogVisible = true
    },
    deleteMilestone(row) {
      delMilestone({ LogId: row.LogId, SourceType: 'Template' }).then(res => {
        if (res && res.code === 200) {
          this.search()
        }
      })
    },
    onCompanyFormSubmit() {
      this.search()
    },
    reset() {
      this.searchForm = {
        booking_No: '',
        mailSubject: '',
      }
      this.search()
    },
    indexMethod(index) {
      return index * 1 + 1;
    }
  }
}
</script>
<style lang="less">
.page-contract-search {
  padding: 5px;
  background: #f0f6fb;
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
    height: 100px;
  }
  .order-list {
    background: white;
    margin-top: 3px;
    border-radius: 4px;
    padding: 16px 20px;
    .list-item {
      margin-bottom:1px;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .table_content{
    margin-top: 30px;
  }
  .page-container{
  margin-left: 0px;
  }
}
</style>
<style>
 .el-dialog__body {
    text-align: initial;
    padding: 30px 1px;
  }
.el-select ,.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner,.tms-style .el-select--small, .tms-style .el-input__inner{
  max-width: none;
}
.el-autocomplete{
  width: 100%;
}
.el-loading-mask{
  z-index: 1000;
}
.el-dialog{
  width: 30%;
  min-width: 400px;
}
.el-select, .el-date-editor.el-input, .el-date-editor.el-input__inner{
  background:none !important
}
/* .el-autocomplete-suggestion{
  top: 339px !important;
} */
</style>
